import './main.css';
import size from './size';
import getDates from './dates';
import getParam from './get-param';
import {setImageSources} from './images';
import {onDragStart, onTouchStart} from './events';

const handle = document.getElementById('handle');

handle.onmousedown = onDragStart;
handle.ontouchstart = onTouchStart;

getDates();
setImageSources();
size();

if (typeof getParam('modestbranding') !== 'undefined') {
  document.getElementById('logo').style.display = 'none';
}

let timeout;

window.addEventListener('resize', () => {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(size, 150);
});
